interface Props {
  children: React.ReactNode;
  gap: number | string;
}

const FormWrapper = ({ children, gap }: Props) => {
  return (
    <div className="flex flex-col" style={{ gap: gap }}>
      {children}
    </div>
  );
};

export default FormWrapper;
